// extracted by mini-css-extract-plugin
module.exports = {"reviewsFilter":"RSKY12T","filterRow":"dqvLk0P","reviewsFilterLabel":"iAunVxi","edit":"YjivWeF","reviewsFilter-ratings":"wuY3RS_"};